import axios from "axios";
import { toast, Bounce } from "react-toastify";
import { useEffect, useRef, useState } from "react";
import { useAudio, useAudioList } from "../Stores/useAudio";
import { usePlayGif, useGifList } from "../Stores/useGif";
import { useDispatch, useSelector } from "react-redux";
import { getClaims, fullDenial, afcaSowEmailSent, deleteClaim } from "../../action";


export const AFCASOWRow = ({
  address,
  description,
  index,
  claimantId,
  claimantName,
  insurer,
  status,
  sowStarttime,
  firstQuiz,
  secondQuiz,
  type
}) => {
  const jwtToken = localStorage.getItem("jwtToken");
  const [reason, setReason] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const trigger = useRef(null);
  const modal = useRef(null);
  const { setAudioURL } = useAudio();
  const { celebrateAudios } = useAudioList();
  const { setGifSrc, setShowGif } = usePlayGif();
  const { celebrateGifs } = useGifList();
  const [leftDays, setLeftDays] = useState(100);
  const [progress, setProgress] = useState(0);
  const state = useSelector((state) => state.reducer);
  const dispatch = useDispatch();
  const [sowStartFinalTime, setSowStartFinalTime] = useState("");
  // close on click outside
  useEffect(() => {
    const start = new Date(sowStarttime);
    const end = new Date(start);
    end.setDate(start.getDate() + 30);
    const now = new Date();
    const totalDays = (end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);
    const elapsedDays =
      (now.getTime() - start.getTime()) / (1000 * 60 * 60 * 24);
    const remainingDays = Math.max(totalDays - elapsedDays, 0);

    setLeftDays(Math.ceil(remainingDays));
    setProgress(Math.min((elapsedDays / totalDays) * 100, 100));
    if (leftDays === 0) {
      dispatch(afcaSowEmailSent(claimantId));
    }
  }, [sowStarttime, leftDays, dispatch, claimantId]);
  useEffect(() => {
    const clickHandler = ({ target }) => {
      if (!modal.current) return;
      if (
        !modalOpen ||
        modal.current.contains(target) ||
        trigger.current.contains(target)
      )
        return;
      // setModalOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  useEffect(() => {
    if (sowStarttime) {
      const dateObj = new Date(sowStarttime);
      const today = new Date();
      const origianlDate = new Date(dateObj.toDateString());
      const todayDateOnly = new Date(today.toDateString());
      const diffTime = todayDateOnly - origianlDate;
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
      setSowStartFinalTime(diffDays);
    }
  }, [sowStarttime]);

  // close if the esc key is pressed
  useEffect(() => {
    const keyHandler = ({ keyCode }) => {
      if (!modalOpen || keyCode !== 27) return;
      // setModalOpen(false);
    };
    document.addEventListener("keydown", keyHandler);
    return () => document.removeEventListener("keydown", keyHandler);
  });

  const handleDecideAFCASOW = (status) => {
    if (status === "authorize") {
      axios
        .post(
          `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/afca-sow-decision`,
          { decision: "approved", reason: "" },
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.message) {
            toast.success(res.data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Bounce,
            });
            dispatch(getClaims());
            setAudioURL(celebrateAudios);
            setGifSrc(celebrateGifs);
            setShowGif(true);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else if (status === "lost") {
      axios
        .post(
          `https://api.claimdefenderaigame.com:5000/api/claims/${claimantId}/afca-sow-decision`,
          { decision: "denied", reason: reason },
          {
            headers: {
              Authorization: `Bearer ${jwtToken}`,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          if (res.data.message)
            toast.success(res.data.message, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
              transition: Bounce,
            });
          dispatch(getClaims());
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  {
    return type === 1 ? (
      <tr key={index} className="border-t">
        <td className="px-6 py-4 text-center">
          {address}
        </td>
        <td className="px-6 py-4 text-center">{claimantName}</td>
        <td className="px-6 py-4 text-center">{insurer}</td>
        <td className="px-6 py-4 text-center">{description}</td>
        <td className="px-6 py-4 text-center">
          <div className="bg-blue-50 hover:bg-blue-50 px-2 border-blue-100 rounded-2xl w-max text-blue-700">
            {status}
          </div>
        </td>
        <td className="px-6 py-4 text-center">
          <div className="flex flex-col gap-y-1">
            <div className="flex justify-between text-xs">
              <p>Appeal Decision</p>
              <p>{`${leftDays} days left`}</p>
            </div>
            <div className="bg-gray-200 dark:bg-gray-200 rounded-full w-full h-2.5">
              <div
                className="bg-blue-500 rounded-full h-2.5"
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <div className="flex justify-between text-xs">
              <p>Start</p>
              <p>30 Calendar days</p>
            </div>
          </div>
        </td>
        <td className="px-6 py-4 text-center">
          {firstQuiz}<br />
          <div className="border border-bg-gray-300"></div>
          {secondQuiz}
        </td>
        <td className="px-6 py-4 text-center">
          <div className="flex gap-2 w-full max-w-md">
            {/* Won Button - Fixed width */}
            <button
              onClick={() => handleDecideAFCASOW("authorize")}
              className="w-24 px-2 py-2 rounded-md text-white text-sm font-medium bg-gradient-to-br from-green-400 to-green-600 shadow-lg hover:scale-105 hover:from-green-500 hover:to-green-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95"
            >
              <span className="relative z-10">Won</span>
            </button>

            {/* Lost Button - Flex 1 */}
            <button
              ref={trigger}
              onClick={() => setModalOpen(true)}
              className="relative flex-1 px-2 py-2 rounded-md text-white text-sm font-medium bg-gradient-to-br from-red-500 to-red-700 shadow-lg hover:scale-105 hover:from-red-600 hover:to-red-800 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
            >
              <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
              <span className="relative z-10">Lost</span>
            </button>

            {/* Undo Button - Flex 1 */}
            <button
              ref={trigger}
              onClick={(e) => dispatch(fullDenial(claimantId, "undo"))}
              className="relative flex-1 px-2 py-2 rounded-md text-white text-sm font-medium bg-gradient-to-br from-yellow-400 to-orange-600 shadow-lg hover:scale-105 hover:from-yellow-500 hover:to-orange-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
            >
              <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
              <span className="relative z-10">Undo</span>
            </button>
          </div>

          {/* Lost Modal */}
          <div
            className={`fixed left-0 top-0 flex h-full min-h-screen w-full items-center justify-center bg-dark/90 px-4 py-5 ${
              modalOpen ? "block" : "hidden"
            }`}
          >
            <div
              ref={modal}
              className="bg-white dark:bg-dark-2 shadow-lg p-5 rounded-[20px] w-full max-w-[570px] text-center"
            >
              <div className="flex flex-col gap-4">
                <textarea
                  className="p-2 border w-full"
                  cols="30"
                  rows="5"
                  onChange={(e) => setReason(e.target.value)}
                ></textarea>
                <button
                  onClick={() => {
                    handleDecideAFCASOW("lost");
                    setModalOpen(false);
                  }}
                  className="bg-blue-600 py-2 text-white rounded-md"
                >
                  OK
                </button>
                <button
                  onClick={() => setModalOpen(false)}
                  className="bg-gray-300 py-2 text-black rounded-md"
                >
                  Cancel
                </button>
              </div>
            </div>
        </div>
        </td>
      </tr>
    ) : (
    <>
      <td className="px-6 py-4 text-center">
        <div className="flex flex-col gap-y-1">
          <div className="flex justify-center text-xs">
            {/* <p>Appeal Decision</p> */}
            <p>{`${leftDays} days left`}</p>
          </div>
          <div className="bg-gray-200 dark:bg-gray-200 rounded-full w-full h-2.5">
            <div
              className="bg-blue-500 rounded-full h-2.5"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
          <div className="flex justify-center text-xs">
            {/* <p>Start</p> */}
            <p>30 Calendar days</p>
          </div>
        </div>
      </td>
      <td className="px-6 py-4 text-center">{firstQuiz}</td>
      <td className="px-6 py-4 text-center">
        {
          state.role === 0 ? (
            <div className="flex gap-2 w-full max-w-md">
              {/* Won Button - Fixed width */}
              <button
                onClick={() => handleDecideAFCASOW("authorize")}
                className="w-24 px-2 py-2 rounded-md text-white text-sm font-medium bg-gradient-to-br from-green-400 to-green-600 shadow-lg hover:scale-105 hover:from-green-500 hover:to-green-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95"
              >
                <span className="relative z-10">Won</span>
              </button>

              {/* Lost Button - Flex 1 */}
              <button
                ref={trigger}
                onClick={() => setModalOpen(true)}
                className="relative flex-1 px-2 py-2 rounded-md text-white text-sm font-medium bg-gradient-to-br from-red-500 to-red-700 shadow-lg hover:scale-105 hover:from-red-600 hover:to-red-800 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
              >
                <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                <span className="relative z-10">Lost</span>
              </button>

              {/* Undo Button - Flex 1 */}
              <button
                ref={trigger}
                onClick={(e) => dispatch(fullDenial(claimantId, "undo"))}
                className="relative flex-1 px-2 py-2 rounded-md text-white text-sm font-medium bg-gradient-to-br from-yellow-400 to-orange-600 shadow-lg hover:scale-105 hover:from-yellow-500 hover:to-orange-700 hover:shadow-2xl transform transition-all duration-300 ease-in-out active:scale-95 animate-pulse-glow"
              >
                <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
                <span className="relative z-10">Undo</span>
              </button>
            </div>
          ) : (
            <button
              onClick={(e) => dispatch(deleteClaim(claimantId, state.currentUserName))}
              className="relative px-5 py-2 tracking-wide text-white uppercase rounded-lg bg-gradient-to-br from-red-400 to-red-600 shadow-lg transition duration-300 ease-in-out transform hover:scale-105 hover:from-red-500 hover:to-red-700 hover:shadow-2xl active:scale-95 animate-pulse-glow"
            >
              <span className="absolute inset-0 bg-white opacity-10 blur-sm animate-glow-wave"></span>
              <span className="relative z-10">Delete</span>
            </button>
          )
        }
        

        {/* Lost Modal */}
        <div
          className={`fixed left-0 top-0 flex h-full min-h-screen w-full items-center justify-center bg-dark/90 px-4 py-5 ${
            modalOpen ? "block" : "hidden"
          }`}
        >
          <div
            ref={modal}
            className="bg-white dark:bg-dark-2 shadow-lg p-5 rounded-[20px] w-full max-w-[570px] text-center"
          >
            <div className="flex flex-col gap-4">
              <textarea
                className="p-2 border w-full"
                cols="30"
                rows="5"
                onChange={(e) => setReason(e.target.value)}
              ></textarea>
              <button
                onClick={() => {
                  handleDecideAFCASOW("lost");
                  setModalOpen(false);
                }}
                className="bg-blue-600 py-2 text-white rounded-md"
              >
                OK
              </button>
              <button
                onClick={() => setModalOpen(false)}
                className="bg-gray-300 py-2 text-black rounded-md"
              >
                Cancel
              </button>
            </div>
          </div>
      </div>
      </td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td className="text-center border-t">
        {
          sowStartFinalTime === 0 ? "Today" : (`${sowStartFinalTime} days`)
        }
      </td>
    </>
    )
  }
};
